import { useState } from 'react';
import customAxios from 'routes/Pages/util/Api';
import authHeader from 'services/auth/jwt/auth-header';

export function useSendContractNotification() {
  const [sending, setSending] = useState(false);

  const sendNotification = async ({ subject, body, sendTo, deliveryType = 'EMAIL', primaryKey, templateType, rawData, uniqueRef, notificationSection }) => {
    try {
      setSending(true);

      const payload = {
        sendTo,
        notificationSubject: subject,
        notificationBody: body,
        smsBody: deliveryType === 'SMS' ? body : null,
        notificationDeliveryType: deliveryType,
        flag: 0,
        primaryKey,
        templateType,
        rawData: rawData ?? body,
        notificationUniqueId: `${primaryKey ?? uniqueRef}`,
        notificationSection: notificationSection || 'Contract',
      };

      await customAxios.post('/GenTasks/AddNotifications', payload, {
        headers: authHeader(),
      });

      return true;
    } catch (e) {
      console.error('Notification send failed', e);
      return false;
    } finally {
      setSending(false);
    }
  };

  return { sendNotification, sending };
}
